import React, { useState } from "react";
import { useHistory } from "react-router-dom";
// import { FiFileText, FiMoreVertical } from "react-icons/fi";
import StatusBadge from "./StatusBadge";
import TableFooter from "./TableFooter";
// import { FiEye, FiEdit2 } from "react-icons/fi";

const PAGE_SIZE = 10;

export default function EmployeeTable({

  columns = [], list = [], totalCount = 0, getEmpList, onNameChange }) {

  const history = useHistory();
  const [currentPage, setCurrentPage] = useState(1);
  const [isOpen, setIsOpen] = useState(false);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    if (typeof getEmpList === "function") {
      getEmpList(page, PAGE_SIZE);
    }
  };

  const getUserGradient = (name = "") => {
    const gradients = [
      "from-indigo-500 to-purple-600",
      "from-blue-500 to-cyan-500",
      "from-pink-500 to-rose-500",
      "from-violet-500 to-fuchsia-500",
      "from-emerald-500 to-teal-500",
      "from-orange-500 to-amber-500",
      "from-cyan-500 to-blue-600",
      "from-purple-500 to-indigo-600",
      "from-rose-500 to-orange-500",
      "from-teal-500 to-green-500",
    ];
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    const index = Math.abs(hash) % gradients.length;
    return gradients[index];
  };

  const getInitials = (name = "") => {
    if (name) {
      const parts = name.trim().split(/\s+/).filter(Boolean);
      if (parts.length === 1) {
        return parts[0][0].toUpperCase();
      }
      return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
    } else {
      return ""
    }

  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
  };

  return (
    <>
      <div className="mt-6 w-full max-w-full bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden">

        <div className="w-full overflow-x-auto ounded-2xl">
          <table className="min-w-[1200px] w-full border-collapse text-left">
            <thead className="bg-indigo-50">
              <tr>
                {columns.map((col) => (
                  <th key={col.value || col.col} className="lg:px-6 px-3 py-4 text-sm font-semibold uppercase text-gray-700 whitespace-nowrap">  {col.label}</th>
                ))}
              </tr>
            </thead>

            <tbody className="divide-y divide-gray-100">
              {list.map((item, index) => {
                const isLastRow = index >= list.length - 2;

                return (
                  <tr
                    key={item.id}
                    className="hover:bg-indigo-50/30 transition-colors"
                  >
                    {columns.map(({ col }) => {
                      switch (col) {
                        case "name":
                          return (
                            <>
                              {item && item.name ?
                                <td key={col} className="lg:px-6 px-3 py-4 whitespace-nowrap">
                                  <div className="flex items-center gap-3">
                                    <div className={`w-12 h-12 rounded-2xl flex items-center justify-center border-2 border-white bg-gradient-to-br ${getUserGradient(item.name)}`}>
                                      <h2 className="text-xl font-semibold text-white uppercase">{getInitials(item.name)}</h2>
                                    </div>
                                    <div className="min-w-0"> <p className="text-sm font-semibold text-gray-900 truncate">{item.name}</p>
                                      <p className="text-xs text-gray-500 truncate">{item.email}</p>
                                    </div>
                                  </div>
                                </td> :
                                <td key={col} className="lg:px-6 px-3 py-4 whitespace-nowrap">
                                  <div className="flex items-center gap-3">
                                    <div className={`w-12 h-12 rounded-2xl flex items-center justify-center border-2 border-white bg-gray-200 `}>
                                      <h2 className="text-xl font-semibold text-gray-400 uppercase">{"NA"}</h2>
                                    </div>
                                    <div className="min-w-0"> <p className="text-sm font-semibold text-gray-500 truncate">{"Not Available"}</p>
                                    </div>
                                  </div>
                                </td>

                              }
                            </>
                          );


                        case "used":
                          return (
                            <td className="py-3 lg:px-6 px-3 text-sm font-medium">
                              {item.used ? (
                                <span className="text-emerald-700">Yes</span>
                              ) : (
                                <span className="text-red-500">No</span>
                              )}
                            </td>
                          );


                        case "code":
                          return (
                            <td className="py-3 lg:px-6 px-3">
                              <div className="flex items-center gap-2">
                                <div className="px-8 py-1.5 border-2 min-w-56 text-center border-dashed border-green-300 rounded-md text-green-500 text-sm font-medium">
                                  {item.code}
                                </div>
                                <button onClick={() => copyToClipboard(item.code)} title="Copy" className="p-1.5 rounded-lg bg-gray-100 text-gray-500  focus:bg-green-100 hover:bg-gray-200 transition-colors">
                                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                                  </svg>
                                </button>
                              </div>
                            </td>
                          );

                        case "status":
                          return (
                            <td key={col} className="lg:px-6 px-3 py-4 whitespace-nowrap">
                              <StatusBadge status={item.status} />
                            </td>
                          );


                        default:
                          return (
                            <td key={col} className="lg:px-6 px-3 py-4 text-xs sm:text-sm text-gray-600 whitespace-nowrap">  {item[col]}</td>
                          );
                      }
                    })}
                  </tr>
                );
              })}
            </tbody>

          </table>
        </div>

        <TableFooter
          shown={list.length}
          total={totalCount || list.length}
          totalCount={totalCount}
          currentPage={currentPage}
          onPageChange={handlePageChange}
        />
      </div >
    </>
  );
}